import kinks from '@turf/kinks';
import type {
  Feature,
  LineString,
  MultiLineString,
  MultiPolygon,
  Polygon,
} from 'geojson';

type SelfIntersectingGeometry =
  | Polygon
  | MultiPolygon
  | LineString
  | MultiLineString;

const isSelfIntersectingGeometry = (
  geometry: Feature['geometry'],
): geometry is SelfIntersectingGeometry =>
  geometry != null &&
  (geometry.type === 'Polygon' ||
    geometry.type === 'MultiPolygon' ||
    geometry.type === 'LineString' ||
    geometry.type === 'MultiLineString');

/**
 * Returns true when a GeoJSON feature has edges that cross each other.
 */
const hasSelfIntersection = (feature: Feature): boolean => {
  if (!feature.geometry || !isSelfIntersectingGeometry(feature.geometry)) {
    return false;
  }

  return (
    kinks(feature as Feature<SelfIntersectingGeometry>).features.length > 0
  );
};

export default hasSelfIntersection;
